import { useMemo } from 'react';
import { FILTER_CONTENT_TYPE } from '../constants/FilterConstants';
import { isArrayWithLength } from '../utils/common-methods';

const useSearchFilterParam = (props) => {
  const { filterKey, filterParams = {}, sort = '', searchText = '', extraParam = '' } = props;
  const { FILTER = {} } = filterKey;

  let filterParamString = '';
  const searchFilterParam = useMemo(() => {
    Object.keys(FILTER).map((key) => {
      const { type, value: paramKey } = FILTER[key];
      if (type === FILTER_CONTENT_TYPE.DATE_RANGE_PICKER) {
        const fromDate = filterParams[paramKey]?.from;
        const toDate = filterParams[paramKey]?.to;
        const { rangeKey } = FILTER[key];
        // Check if rangeKey has a valid value (not undefined, '', or null)
        if (rangeKey) {
          filterParamString =
            filterParamString +
            `${fromDate ? `${rangeKey}DateFrom=${fromDate}&` : ''}${toDate ? `${rangeKey}DateTo=${toDate}&` : ''}`;
        } else {
          // logic when rangeKey is falsy
          filterParamString =
            filterParamString + `${fromDate ? `dateFrom=${fromDate}&` : ''}${toDate ? `dateTo=${toDate}&` : ''}`;
        }
      } else if (type === FILTER_CONTENT_TYPE.TOGGLE) {
        filterParamString = filterParamString + `${paramKey}=${filterParams?.[paramKey] || false}&`;
      } else {
        const value = isArrayWithLength(filterParams?.[paramKey])
          ? filterParams?.[paramKey]?.map((item) => item?.id) || ''
          : filterParams?.[paramKey]?.value || '';

        // Only add parameter if it has a non-empty value
        if (value && value !== '') {
          filterParamString = filterParamString + `${paramKey}=${value}&`;
        }
      }
    });
    filterParamString = filterParamString.length > 0 ? filterParamString.slice(0, -1) : '';
    const filterArr = [
      filterParamString,
      `${searchText ? `q=${searchText}` : ''}`,
      `${sort ? `sort=${sort}` : ''}`,
      extraParam,
    ].filter((value) => value);

    const newSearchParams = filterArr.join('&');
    return newSearchParams;
  }, [filterParams, searchText, sort, extraParam]);

  return searchFilterParam;
};

export default useSearchFilterParam;
